import PhraseShare from './PhraseShare.component';

export default PhraseShare;
